/**
 * @generated SignedSource<<632f4885ba0c8308b7490de2a0055e9f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs, Result } from "relay-runtime";
export type useShareAndRestrictButtonFragment_content$data = Result<{
  readonly hasInheritedRestrictions: boolean;
  readonly hasRestrictions: boolean;
  readonly hasViewRestrictions: boolean;
  readonly id: string | null;
  readonly title: string | null;
  readonly " $fragmentType": "useShareAndRestrictButtonFragment_content";
}, unknown>;
export type useShareAndRestrictButtonFragment_content$key = {
  readonly " $data"?: useShareAndRestrictButtonFragment_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"useShareAndRestrictButtonFragment_content">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "catchTo": "RESULT"
  },
  "name": "useShareAndRestrictButtonFragment_content",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "hasInheritedRestrictions"
    },
    {
      "kind": "ScalarField",
      "name": "hasRestrictions"
    },
    {
      "kind": "ScalarField",
      "name": "hasViewRestrictions"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    }
  ],
  "type": "Content"
};

(node as any).hash = "91bc937b1623b5b33dfb2acccf465d82";

export default node;
